import { VISITOR } from 'app/routes'
import { ChevronLeftIcon } from 'assets/icons'
import { Container } from 'components/Container'
import { useNavigate } from 'react-router-dom'
import FormattedMessage from 'utils/FormattedMessage'

export const TicketPageHeader = () => {
  const navigate = useNavigate()

  return (
    <div className='bg-custom-header h-[68px]'>
      <Container className='flex items-center h-full relative'>
        <div className='flex absolute left-[16px]'>
          <button onClick={() => navigate(VISITOR.TICKETS)}>
            <ChevronLeftIcon />
          </button>
        </div>
        <div className='flex items-center h-full pl-10'>
          <h1 className='text-xl md:text-2xl font-bold text-gray-900 dark:text-gray-100'>
            <FormattedMessage id='myVisits' />
          </h1>
        </div>
      </Container>
    </div>
  )
}
